import moment from 'moment';

export const getMondayFirstWeekdays = (language?: string) => {
  const sundayFirst = moment.localeData(language).weekdaysMin();
  return [...sundayFirst.slice(1), sundayFirst[0]];
};
